<template>
    <b-container class="p-0">
        <b-row class="my-2 ">
            <b-col>
                <h6 class="font-weight-normal">Property Details</h6>
            </b-col>
        </b-row>
        <b-row class="shadow-sm m-0 mb-4 pt-2 rounded-lg">
            <b-col>
                <b-form-group label="Section Label">
                    <b-form-input v-model="section.label" />
                </b-form-group>
            </b-col>
            <b-col cols="auto">
                <b-form-group label="Select Section Type">
                    <b-form-select 
                        v-model="section.type"
                        :options="[
                            {text:'Roof', value:'roof'},
                            {text:'Equipment', value:'equipment'}
                        ]"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="isEquipment" class="shadow-sm m-0 rounded-lg">
            <b-col class="py-2">
                <label for=""><small>Equipment Type</small></label>
                <b-row>
                    <b-col class="text-capitalize">
                        {{( (equipment && equipment.name) || 'Select Equipment').replaceAll('_',' ')}}
                    </b-col>
                    <b-col cols="auto">
                        <b-dropdown 
                            right 
                            size="sm"
                            variant="link" 
                            class="equipment-list"
                            toggle-class="text-decoration-none" 
                            no-caret
                        >
                            <template #button-content>
                                <font-awesome-icon 
                                    icon="pencil" 
                                    class="text-primary"
                                />
                            </template>
                            
                            <b-dropdown-item 
                                v-for="(item, index) in equipments" 
                                @click="selectEquipment(item)"
                                v-bind:key="index">
                                <small class="text-capitalize">{{item.name.replaceAll("_"," ")}}</small>
                            </b-dropdown-item>
                        </b-dropdown>
                    
                        
                    </b-col>
                
                </b-row>
                <!-- <hr class="my-2"/> -->
                <!-- <div class="text-muted" style="font-size:10px">
                    Fixe 
                    <font-awesome-icon icon="angle-right" />
                    Double
                    <font-awesome-icon icon="angle-right" />
                    Polycarbonate massif
                </div> -->
            </b-col>
        </b-row>
        <b-container  class="rounded-lg shadow-sm">
            <b-row v-if="isEquipment && equipment"  class="mt-4 py-3" cols="2">
                <template v-for="field,index in equipment.fields_data" >
                    <b-col :key="`f-0-${index}`">
                        <equipment-sub-fields :fields="fields" :index="index" :field="field" />
                    </b-col>
                    <template v-for="subfield,index in subfields(field,index)" >
                        <b-col :key="`f-1-${index}`">
                            <equipment-sub-fields :fields="fields" :index="index" :field="subfield" />
                        </b-col>
                        <template v-for="subfield,index in subfields(subfield,index)" >
                            <b-col :key="`f-2-${index}`">
                                <equipment-sub-fields :fields="fields" :index="index" :field="subfield" />
                            </b-col>
                        </template>
                    </template>
                </template>
            
            </b-row>
            <b-row class="py-3">
                <b-col class="text-right">
                    <b-btn variant="outline-dark" size="sm" @click="show=false">ANNULER</b-btn>
                    <b-btn 
                        class="ml-2" 
                        size="sm" 
                        variant="primary"
                        @click="submitHandler"
                    >
                    <b-spinner v-if="loading" small label="Loading..."></b-spinner>
                    SOUMETTRE
                    </b-btn>
                </b-col>
            </b-row>
        </b-container>
    </b-container>
</template>
<script>
import {ModalMixin} from '@/mixins';
import { mapGetters } from 'vuex';
import EquipmentSubFields from '../EquipmentSubFields.vue';

export default {
    name: "PolygonProperyModal",
    mixins:[ModalMixin],
    components:{
        EquipmentSubFields
    },
    data(){
        return {
            // data is added by modalmixin
            loading: false,
            fields: {},
            section: {
                type: "roof",
                label: "",
            },
            equipment: "", 
        };
    },
    computed: {
        ...mapGetters({
            'equipments' : 'equipments/items',
            'image': 'assets/assetDetail',
            'project': 'projects/item',
            'scale': 'assets/scale',
        }),
        isEquipment(){
            return this.section.type == 'equipment'
        },
        fieldList(){
            return this.equipment.fields || []
        }
    },
    methods: {
        sanitise(options){
            return Array.isArray(options)? options : Object.keys(options)
        },
        subfields(field, index){
            if(index in this.fields && 'options' in field && !Array.isArray(field.options)){
                return field.options[this.fields[index]].fields || []
            }else{
                return [];
            }            
        },
        selectEquipment(item, index){
            this.equipment = item 
        },
        submitHandler(){
            this.loading = true
            let coords = this.data.polygon.segments.map(segment=>{
                return {
                    x: segment.point.x * this.scale,
                    y: segment.point.y * this.scale
                }
            });
            let shape_type = this.section.type == 'roof' ? "" :  this.equipment.shape_type
            let payload = {
                section: {
                    asset_detail_id: this.image.id,
                    coords: coords ,
                    shape_type: shape_type,
                    section_type: this.section.type,
                    project_id: this.project.id,
                    label: this.section.label
                },
                
            }
            if(this.section.type){
                payload.section.equipment_detail = {
                    equipment_config_id: this.equipment.id,
                    equipment_type: this.equipment.name,
                    data: this.fields
                }
            }
            this.$store.dispatch('sections/create', {
                projectId: this.project.id,
                payload: payload,
            }).then(()=>{

            }).finally(()=>{
                this.loading = false
                this.$store.dispatch('ui/modal.close')
            })
        }
    }
    
}
</script>

<style>
    .equipment-list .dropdown-menu{
        overflow: scroll;
        max-height: 50vh;
    }
    
    .equipment-list .dropdown-menu li+li{
        border-top: 1px solid #ccc;
    } 
    fieldset.form-group legend {
        text-transform: capitalize;
    }
</style>